import React, { Component } from "react";
import EditLink from "./links/EditLink";
import ShowLink from "./links/ShowLink";
import ConvertLink from "./links/ConvertLink";

class WalkIn extends Component {
  render() {
    const { id, notes, place, admin, consultation } = this.props;
    const content = admin ? <ShowLink id={id}/> : <EditLink id={id} />
    return (
      <div className="box is-info">
        <article className="media ">
          <div className="media-left">
            <p>
              {place.name}
            </p>
          </div>
          <div className="media-content">
            <div className="content">
              <p >
                | {place.vicinity}
              </p>
            </div>
          </div>
          <ConvertLink id={id} consultation={consultation}/>
          { content }
        </article>
      </div>
    );
  }
}

export default WalkIn;
